import { useCallback, useEffect } from 'react';
import { isEscapeKey } from '@peloton/keyboard'; // Using this instead on waffles' useOnUserEscaped because we
// need to be able to escape even when there is no active Pocket.

export var useRemoteControlBackButton = function useRemoteControlBackButton(cb, getIsTVOnline, callWhenOffline) {
  var onEscape = useCallback(function (event) {
    if (isEscapeKey(event)) {
      var isTVOnline = getIsTVOnline();

      if ( // only call the callback when there is no offline error
      isTVOnline && !callWhenOffline || // unless we set callWhenOffline to true
      !isTVOnline && callWhenOffline) {
        event.preventDefault();
        cb();
      }
    }
  }, [callWhenOffline, cb, getIsTVOnline]);
  useEffect(function () {
    document.body.addEventListener('keydown', onEscape);
    document.body.addEventListener('keypress', onEscape);
    return function () {
      document.body.removeEventListener('keydown', onEscape);
      document.body.removeEventListener('keypress', onEscape);
    };
  }, [onEscape]);
};